import React, { useState } from 'react'
import { Box, Container, Grid, Typography, IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import wave1 from '../assets/images/AZ8_7174.jpg'
import wave2 from '../assets/images/AZ8_6420.jpg'
import wave3 from '../assets/images/AZ8_6268.jpg'

const StyledSubtitle = styled(Typography)(({ theme }) => ({
  color: '#000',
  marginBottom: theme.spacing(3),
  transition: 'opacity 0.3s ease-in-out',
}))

const TextContainer = styled(Box)({
  position: 'relative',
  minHeight: '300px',
})

const ContentWrapper = styled(Box)({
  position: 'absolute',
  width: '100%',
  transition: 'opacity 0.3s ease-in-out',
  opacity: 0,
  '&.active': {
    opacity: 1,
  }
})

const ContentText = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  lineHeight: 1.6,
  display: 'block',
  width: '100%',
}))


const CarouselContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  minHeight: 500,
  overflow: 'hidden',
  [theme.breakpoints.down('md')]: {
    minHeight: 300,
  },
}))

const CarouselImage = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
  top: 0,
  left: 0,
  transition: 'opacity 0.3s ease-in-out',
  opacity: 0,
  '&.active': {
    opacity: 1,
  },
})

const CarouselButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  backgroundColor: 'rgb(255, 255, 255)',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
  },
}))

const CarouselDots = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(2),
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: theme.spacing(1),
}))

const CarouselDot = styled(Box)(({ theme }) => ({
  width: 8,
  height: 8,
  borderRadius: '50%',
  backgroundColor: 'rgba(255, 254, 251, 0.5)',
  cursor: 'pointer',
  transition: 'background-color 0.3s ease-in-out',
  '&.active': {
    backgroundColor: 'rgba(244, 152, 13, 0.93)',
  },
}))
export default function Mobile() {
  const [activeSlide, setActiveSlide] = useState(0)

  const slides = [
    {
      image: wave2,
      title: "Mobile-Phones",
      description1: "We began our manufacturing journey with mobile phones and, over time, have built a robust market presence, successfully catering to both national and international brands. Our commitment to quality, innovation, and customer satisfaction has allowed us to consistently meet the evolving demands of the mobile industry.",
      description2: "By leveraging our core strengths in advanced manufacturing processes, skilled workforce, and cutting-edge technology, BPL has rapidly established itself as one of India’s leading mobile phone manufacturers. Our dedication to excellence has driven our growth, positioning us as a trusted partner for global brands and expanding our footprint in the highly competitive mobile market."
    },
    {
      image: wave1,
      title: "Mobile-Phones",
      description1: "We began our manufacturing journey with mobile phones and, over time, have built a robust market presence, successfully catering to both national and international brands. Our commitment to quality, innovation, and customer satisfaction has allowed us to consistently meet the evolving demands of the mobile industry.",
      description2: "By leveraging our core strengths in advanced manufacturing processes, skilled workforce, and cutting-edge technology, BPL has rapidly established itself as one of India’s leading mobile phone manufacturers. Our dedication to excellence has driven our growth, positioning us as a trusted partner for global brands and expanding our footprint in the highly competitive mobile market."
    },
    {
      image: wave3,
      title: "Mobile-Phones",
      description1: "We began our manufacturing journey with mobile phones and, over time, have built a robust market presence, successfully catering to both national and international brands. Our commitment to quality, innovation, and customer satisfaction has allowed us to consistently meet the evolving demands of the mobile industry.",
      description2: "By leveraging our core strengths in advanced manufacturing processes, skilled workforce, and cutting-edge technology, BPL has rapidly established itself as one of India’s leading mobile phone manufacturers. Our dedication to excellence has driven our growth, positioning us as a trusted partner for global brands and expanding our footprint in the highly competitive mobile market."
    }
  ]

  const handlePrevious = () => {
    setActiveSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1))
  }

  const handleNext = () => {
    setActiveSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1))
  }

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <br/>
      <Grid container spacing={4}>
        <Grid item xs={12} md={5}>
          <TextContainer>
            {slides.map((slide, index) => (
              <ContentWrapper
                key={index}
                className={index === activeSlide ? 'active' : ''}
                sx={{ opacity: index === activeSlide ? 1 : 0 }}
              >
                <StyledSubtitle 
                  variant="h3" 
                  component="h2"
                  sx={{ opacity: index === activeSlide ? 1 : 0 }}
                >
                  {slide.title}
                </StyledSubtitle>
                <ContentText variant="body1">
                  {slide.description1}
                </ContentText>
                <ContentText variant="body1">
                  {slide.description2}
                </ContentText>
              </ContentWrapper>
            ))}
          </TextContainer>
        </Grid>
        <Grid item xs={12} md={7}>
          <CarouselContainer>
          {slides.map((slide, index) => (
              <CarouselImage
                key={index}
                src={slide.image}
                alt={`Slide ${index + 1}`}
                className={index === activeSlide ? 'active' : ''}
              />
            ))}
            <CarouselButton
              onClick={handlePrevious}
              sx={{ left: 16 }}
              aria-label="Previous slide"
            >
              <ChevronLeftIcon />
            </CarouselButton>
            <CarouselButton
              onClick={handleNext}
              sx={{ right: 16 }}
              aria-label="Next slide"
            >
              <ChevronRightIcon />
            </CarouselButton>
            <CarouselDots>
              {slides.map((_, index) => (
                <CarouselDot
                  key={index}
                  className={index === activeSlide ? 'active' : ''}
                  onClick={() => setActiveSlide(index)}
                />
              ))}
            </CarouselDots>
          </CarouselContainer>
        </Grid>
      </Grid>
    </Container>
  )
}